import { useChainId, useConnection, useDisconnect, useSwitchChain } from '@wagmi/vue';
import { computed } from 'vue';
import { useAppConfigStore } from '@src/shared/stores/app-config';

function truncateAddress(address: string): string {
	return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export function useWalletSession() {
	const appConfig = useAppConfigStore();
	const { address: wagmiAddress, isConnected } = useConnection();
	const chainId = useChainId();
	// Без деструктуризации с алиасом: имена deprecated-алиасов wagmi (`disconnect`,
	// `switchChainAsync`) совпадают с полями типа, и no-deprecated флагует такой rename.
	const disconnectMutation = useDisconnect();
	const switchChainMutation = useSwitchChain();
	const isSwitchingChain = switchChainMutation.isPending;

	const address = computed(() => wagmiAddress.value ?? null);

	const addressShort = computed(() => {
		const addr = address.value;
		return addr ? truncateAddress(addr) : null;
	});

	const isWrongNetwork = computed(() => {
		const appChainId = appConfig.selectedChain?.id;
		const walletChainId = chainId.value;
		if (!isConnected.value || appChainId === undefined) {
			return false;
		}
		return walletChainId !== appChainId;
	});

	async function switchToAppChain(): Promise<void> {
		const targetChainId = appConfig.selectedChain?.id;
		if (targetChainId === undefined) {
			return;
		}
		await switchChainMutation.mutateAsync({ chainId: targetChainId });
	}

	return {
		address,
		addressShort,
		chainId,
		disconnect: disconnectMutation.mutate,
		isConnected,
		isSwitchingChain,
		isWrongNetwork,
		switchToAppChain,
	};
}
